import React, { Component } from 'react';

class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dismissed: false
    };
    this.dismissAlert = this.dismissAlert.bind(this);
  }

  dismissAlert() {
    this.setState({ dismissed: true });
  }

  render() {
    if (!this.state.dismissed) {
      return (
        <div className={'alert alert-' + (this.props.type || 'info')}>
          <button type="button" className="close" onClick={this.dismissAlert}>×</button>
          <h4><i className="icon fa fa-info"></i> {this.props.title}</h4>
          <p>{this.props.message}</p>
          {this.props.children}
        </div>
      );
    }
    return null;
  }
}

export default Alert;


// WEBPACK FOOTER //
// ./src/modulos/componentes/Alert.js